import api from './api';

export const reportService = {
    getFilters: async () => {
        const res = await api.get('/reports/filters');
        return res.data;
    },

    getReport: async (type: string, params?: any) => {
        const res = await api.get(`/reports/${type}`, { params });
        return res.data;
    },

    exportReport: async (type: string, format: 'pdf' | 'excel', params?: any) => {
        try {
            const res = await api.get(`/reports/${type}/export`, {
                params: { ...params, format },
                responseType: 'arraybuffer',
            });
            
            // Check if response is an error (HTML error page returned)
            const contentType = res.headers['content-type'];
            if (contentType && contentType.includes('application/json')) {
                const errorData = JSON.parse(new TextDecoder().decode(res.data));
                throw new Error(errorData.message || 'Export failed');
            }
            
            return res.data;
        } catch (error: any) {
            console.error('Export service error:', error);
            throw error;
        }
    },
};
